import React, { useState, useEffect } from 'react'

const Picture = ({
  aspectRatio,
  sizes,
  formats = ['webp', 'png', 'jpg'],
  htmlAttributes,
  className,
  ...props
}) => {
  const [tree, setTree] = useState({ sources: [], img: {} })
  const handle = props.src.split('/').pop()

  const obj = {}
  const list = sizes ? sizes.split(',') : []
  list.forEach(str => {
    const [, key, val] = str.trim().match(/^(\([^)]+\) )?(.*)$/)
    if (key) obj[key.trim()] = val
    else obj.fallback = val.trim()
  })

  const options = {
    ...props,
    ...htmlAttributes,
    formats,
    handle,
    sizes: obj,
  }

  useEffect(() => {
    import('@lineups-io/filestack-adaptive').then(({ makePictureTree }) => {
      const tree = makePictureTree(handle, options)
      setTree(tree)
    })
  }, [handle])

  return (
    <picture>
      {tree.sources ? tree.sources.map((source, i) => <source key={i} {...source} />) : null}
      <img className={className} alt={tree.img.alt} {...htmlAttributes} {...tree.img} />
    </picture>
  )
}

export default Picture
